import { useContext } from 'react'
import { AppConfigContext } from '../context/AppConfigContext'
import { AppConfig } from '../config/app-config'

/**
 * Runtime config for the current environment, supplied by AppConfigProvider in _app.
 * Replaces getConfig().publicRuntimeConfig from next/config.
 */
export const useAppConfig = (): AppConfig => {
  const config = useContext(AppConfigContext)

  if (!config) {
    throw new Error('useAppConfig must be used within an AppConfigProvider with a config')
  }

  return config
}
